import { fetchCommonEventData } from 'api/events';
import { PeopleType } from 'api/people';
import { AxiosError } from 'axios';
import {
  EventStandardContainer,
  EventStandardContainerData,
} from 'components/EventStandardContainer';
import { Props as MetaTagsProps } from 'components/MetaTags';
import { PeopleList } from 'containers/PeopleList';
import { GetStaticPaths, GetStaticProps, InferGetStaticPropsType, NextPage } from 'next';
import { handleAxiosError, IError } from 'utils/handleAxiosError';

export type PageProps = InferGetStaticPropsType<typeof getStaticProps>;

const People: NextPage<PageProps> = ({ data, error }) => (
  <EventStandardContainer
    data={data}
    error={error}
    Component={PeopleList}
    metaTags={data?.metaTags}
  />
);

// TODO: utilise getStaticProps here to improve speed, delivery, and pre-rendering
export const getStaticProps: GetStaticProps<
  {
    data?: EventStandardContainerData<{
      label: string;
      defaultFilter: PeopleType;
      metaTags?: MetaTagsProps;
    }>;
    error?: IError;
  },
  { eventId: string; page: string; limit: string; filter: PeopleType }
> = async ctx => {
  try {
    const eventId = ctx.params?.eventId as string;

    const { eventInfo, tabsConfig } = await fetchCommonEventData(eventId);

    const pageLabel = tabsConfig?.people?.label || 'People';
    const defaultFilter = PeopleType.users;

    return {
      props: {
        data: {
          ...eventInfo,
          tabsConfig,
          label: pageLabel,
          metaTags: {
            title: pageLabel,
          },
          defaultFilter,
        },
      },
      revalidate: 60,
    };
  } catch (err) {
    const error = handleAxiosError(err as AxiosError);

    return {
      props: { error },
      revalidate: 60,
    };
  }
};

export const getStaticPaths: GetStaticPaths = async () => ({ paths: [], fallback: 'blocking' });

export default People;
